import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RegionalUrlService {
  public forRegion(url: string, region: string): string {
    if (region !== 'EU' && region !== 'CA') {
      return url;
    }

    const parsed = new URL(url);
    parsed.hostname = `${region.toLowerCase()}-${parsed.hostname}`;

    return parsed.toString();
  }

  public isWithinEndpoint(url: string, endpoint: string): boolean {
    try {
      const request = new URL(url);
      const base = new URL(endpoint);
      const path = base.pathname.replace(/\/$/, '');

      return request.origin === base.origin && (request.pathname === path || request.pathname.startsWith(`${path}/`));
    } catch (error: unknown) {
      if (error instanceof TypeError) {
        return false;
      }

      throw error;
    }
  }
}
